module.exports = __webpack_public_path__ + "static/media/art.29c67761.png";